// email
export function isNumber(item) {
    const numberReg = /^[0-9]+(\.[0-9]{1,2})?$/
    return numberReg.test(item.trim())
}

// email
export function isEmail(item) {
    const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
    return emailReg.test(item.trim())
}

// molbile
export function isPhone(item) {
    const telReg = /^1\d{10}$/
    return telReg.test(item.trim())
}

// tel
export function isTel(item) {
    const telReg = /^\d{3,4}(-|\s)?\d{3,4}(-|\s)?\d{3,4}$/
    return telReg.test(item.trim())
}

// fax
export function isFax(item) {
    const faxReg = /^(\d{3,4}-)?\d{7,8}$/
    return faxReg.test(item.trim())
}

// uri
export function isURL(item) {
    const urlReg = /^([\w-]+\.)+[\w-]+(\/[\w-.\/?%&=]*)?$/
    return urlReg.test(item.trim())
}

// image
export function isImg(item) {
    const imgReg = /\.(jpg|bmp|gif|ico|pcx|jpeg|tif|png|raw|tga)$/
    return imgReg.test(item)
}

// accept file
export function isAcceptFile(item) {
    const fileReg = /\.(jpg|jpeg|png|pdf|doc|docx|xls|xlsx|ppt|pptx)$/
    return fileReg.test(item)
}

// excel file
export function isExcelFile(item) {
    const fileReg = /\.(xlsx)$/
    return fileReg.test(item)
}

// PDF file
export function isPdfFile(item) {
    const pdfReg = /\.(pdf|PDF|jpg|bmp|gif|jpeg|png)$/
    return pdfReg.test(item)
}

// 验证QQ号码5-11位
export function isQQ(qq) {
    let filter = /^\s*[.0-9]{5,11}\s*$/
    if (!filter.test(qq)) {
        return false
    } else {
        return true
    }
}

// 密码
export function isPassword(str) {
    const reg = /^(?=.*[a-zA-Z])(?=.*\d)[^]{8,}$/

    return reg.test(str)
}

// 域名
export function isDomain(str) {
    const reg = /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62}).+$/

    return reg.test(str)
}

// 网址
export function isWebsite(str) {
    const reg =
        /^(?=^.{3,255}$)(http(s)?:\/\/)?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+\.\w+)*([\?&]\w+=\w*)*$/

    return reg.test(str)
}
// 正数（包括小数）
export function isPositiveNumber(str) {
    const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
    return reg.test(str)
}
// 非负数（包含0）
export function isNonnegativeNumber(str) {
    const reg = /^\d+(\.{0,1}\d+){0,1}$/
    return reg.test(str)
}

// 是否包含空格，逗号(场景：资料编码和商品编码)
export function isHaveSpaceAndComma(str) {
    if (!str) {
        return false
    }
    return str.match(/(\,|\，)/) || str.match(/(\ |\　)/)
}

// 包含首位空格、逗号(场景：资料编码和商品编码)
export function isHaveComma(str) {
    if (!str) {
        return false
    }
    return str.match(/(\,|\，)/) || str.match(/(^\s)|(\s$)/g)
}

// 是否包含空格
export function isHaveSpace(str) {
    if (!str) {
        return false
    }
    return str.match(/(\ |\　)/)
}

// 只能数字
export function isNum(str) {
    if (!str) {
        return false
    }
    const reg = /^[\d]+$/
    return reg.test(str)
}

export const DECIMAL_REGEXP_ONE = /^\-{0,1}(([1-9]{1}\d*)|(0{1}))(\.\d{1})?$/

// 正则表达式,验证最多2位小数
export const DECIMAL_REGEXP = /^\-{0,1}(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
// 正则表达式,验证最多4位小数
export const DECIMAL_REGEXP_FOUR = /^\-{0,1}(([1-9]{1}\d*)|(0{1}))(\.\d{1,4})?$/
// 正则表达式，验证整数
export const INTEGER_REGEXP = /^-?\d+$/

export function is_decimal(number) {
    const reg = DECIMAL_REGEXP
    return reg.test(number)
}
export function is_decimalFour(number) {
    const reg = DECIMAL_REGEXP_FOUR
    return reg.test(number)
}

export function is_decimalOne(number) {
    const reg = DECIMAL_REGEXP_ONE
    return reg.test(number)
}

export function is_integer(number) {
    const reg = INTEGER_REGEXP
    return reg.test(number)
}
